import { API, HOST, PATH, processObjRec } from './common';

/**
 * Constants used for Dev Environment
 */
export const environment = {
    production: false,
    base: HOST + PATH,
    path: PATH,
    api: API
};

/**
 * Combine Consts
 */
processObjRec(environment.api, HOST + PATH);
